export enum ReportFilterParametersEnum {
  'Data de Criação' = 'created_at',
  'Data de Entrega' = 'data_entrega',
  'Data de Publicação' = 'data_publicacao',
}
